export default "<button (click)=\"migrarEstados()\">Migrar estados</button>\n<button (click)=\"migrarCiudades()\">Migrar ciudades</button>"